
<template>
    <ul class="tabs">
        <li v-for="categories in slideBarCategories"><a
            :href="$store.state.hrefPrefix + '/category/' + categories.slug">
            {{article.category.category_languages[0].pivot.name}}
        </a></li>
    </ul>
    <div class="Analysis-list">
        <div class="Analysis-list-left img-scale-in" style="width: 25%; height: 150px;">
            <a :href="$store.state.hrefPrefix + '/articles/' + article.slug"><img v-if="article.blob" :src="article.blob.url" alt=""/></a>
        </div>
        <div class="Analysis-list-right">
            <div class="Analysis-right-top">
                <h2><a :href="$store.state.hrefPrefix + '/category/' + article.category.slug"> {{article.category.category_languages[0].pivot.name }} </a></h2>
                <span>{{article.published_at ?? article.created_at}}</span>
            </div>
            <h3><a :href="$store.state.hrefPrefix + '/articles/' + article.slug">{{ article.article_languages[0].pivot.title }}</a></h3>
            <p v-if="article.second_author == null">{{ $t('by') }} <b>{{ article.author.author_languages[0].pivot.name }}</b></p>
            <p v-else>{{ $t('by') }} <b>{{ article.author.author_languages[0].pivot.name }}</b> & <b>{{ article.second_author.author_languages[0].pivot.name }}</b></p>
        </div>
    </div>
</template>

<script>
export default {
    name: "ListSecondArticle",
    props: {
        slideBarCategories: {
            type: Array,
            default: []
        },
        article: {
            type: Object,
            default: null
        }
    }
}
</script>


<style scoped>

</style>
